/**
 * Configuration Types - Additional Categories
 *
 * Additional categories configuration types
 */

import type { FormField } from '../ui';
import type {
  ConnectorParameterBindingKind,
  ConnectorParameterDestination,
} from './connector.types';

export const ADDITIONAL_CATEGORIES_PROJECT_PARAMETER_CATEGORY_OPTIONS = [
  'Pipe Fittings',
  'Pipe Accessories',
  'Generic Models',
  'Mechanical Equipment',
] as const;

export type AdditionalCategoriesProjectParameterCategory =
  (typeof ADDITIONAL_CATEGORIES_PROJECT_PARAMETER_CATEGORY_OPTIONS)[number];

export const DEFAULT_ADDITIONAL_CATEGORIES_PROJECT_PARAMETER_CATEGORIES:
  AdditionalCategoriesProjectParameterCategory[] = [
    'Pipe Fittings',
    'Pipe Accessories',
    'Generic Models',
    'Mechanical Equipment',
  ];

// =============================================================================
// Additional Categories Configuration
// =============================================================================

/**
 * Additional categories page configuration
 */
export interface AdditionalCategoriesConfiguration {
  /** Where additional-category parameters should be created */
  parameterDestination: ConnectorParameterDestination;
  /** Whether additional-category parameters are type or instance scoped */
  parameterBindingKind: ConnectorParameterBindingKind;
  /** Project categories used when additional-category parameters are created as project parameters */
  projectParameterCategories: AdditionalCategoriesProjectParameterCategory[];
  /** Valve tag value */
  valveTagValue: FormField;
  /** Supports tag value */
  supportsTagValue: FormField;
  /** Supports SSREF value */
  supportsSsrefValue: FormField;
  /** Instrument tag value */
  instrumentTagValue: FormField;
}

export type AdditionalCategoriesFormFieldKey = Exclude<
  keyof AdditionalCategoriesConfiguration,
  'parameterDestination' | 'parameterBindingKind' | 'projectParameterCategories'
>;
